<template>
  <a-modal v-model="visible" :title="title" :destroyOnClose="true" :width="450" @cancel="clearForm">
    <a-form-model ref="changeTrialPeriodForm" layout="vertical">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="End Trial Date" prop="trialEnd">
            <DateTimePickr :hasDefaultValue="false" :date="trialEndDate" @input="onEndDateChange" @onChange="onEndDateChange" minDate="today"></DateTimePickr>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Plan" prop="plan">
            <a-select v-model="planId" style="width: 100%" placeholder="Plan">
              <a-select-option v-for="plan in plans" :key="plan.id" :value="plan.id">
                {{ plan.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="Override Plan Unit Price" prop="overrideUnitPrice">
            <a-input-number class="width-100" :min="0" :max="99999999" v-model="overrideUnitPrice" :formatter="value => `£ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\£\s?|(,*)/g, '')" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="No. of subscribers" prop="overrideUnitPrice">
            <a-input-number class="width-100" placeholder="No. of subscribers" :min="1" :max="1000" v-model="quantity" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="14">
        <p style="color:red">If you don't fill "End Trial Date" we will charge the customer immediately. For other fields, we will use the existing data.</p>
      </a-row>
    </a-form-model>
    <template #footer>
      <a-button type="primary" :loading="isLoading" @click="recreate">Recreate</a-button>
      <a-button @click="cancel">Cancel</a-button>
    </template>
  </a-modal>
</template>

<script>
import modalMixin from '../Common/Mixins/modalMixin';
import {instancesMutations } from '../../Store/store.js';

export default {
  mixins: [modalMixin],
  props: {
    plans: {
      default: () => ([]),
    },
    companySubscriptionId: Number,
    isSaving: Boolean,
    trialEnd: String,
  },
  data() {
    return {
      overrideUnitPrice: null,
      quantity: null,
      planId: null,
      isLoading: false,
      trialEndDate: null,
    };
    },
    watch: {
      trialEnd() {
        this.trialEndDate = this.trialEnd;
      },
    },
  methods: {
    onEndDateChange(newDate) {
      if (newDate) {
        this.trialEndDate = newDate;
      }
      else {
        this.trialEndDate = null;
      }
    },
    clearForm() {
      this.overrideUnitPrice = null;
      this.quantity = null;
      this.planId = null;
      this.trialEndDate = null;
    },
    async recreate() {
      const self = this;
      this.$confirm({
        title: 'Recreate Subscription',
        content: 'By recreating the subscription, the previous subscription will be canceled and a new subscription will be created, are you sure?',
        okText: 'Recreate',
        okType: 'danger',
        cancelText: 'Cancel',
        async onOk() {
         if (self.quantity * self.overrideUnitPrice > 99999999) {
           self.showError("Price should be less than 999,999,99");
           return;
          }
          self.isLoading = true;
          try {
						await instancesMutations.recreateSubscription(self.companySubscriptionId, self.trialEndDate, self.planId, self.quantity, self.overrideUnitPrice);
            self.clearForm();
            self.$message.success("Subscription recreated successfully.");
          }
          catch (error) {
            self.showError(error);
          }
          finally {
            self.isLoading = false;
            self.$emit('onSaved');
          }
        },
        onCancel() {
         
        },
    });
   }
  },
};
</script>

<style lang="scss" scoped>
.update-trial-col {
  padding-top: 3px;
}
</style>
